var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.72222C1 2.49492 2.00736 1.5 3.25 1.5H11.6055C12.8481 1.5 13.8555 2.49492 13.8555 3.72222L13.8752 9.42754L13.8555 12.2778C13.8555 13.5051 12.8481 14.5 11.6055 14.5H3.25C2.00736 14.5 1 13.5051 1 12.2778V3.72222Z",
    stroke: "#B0B0B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1055 4.83333H7.3555M13.8752 10.3867L18.5252 12.6771C19.0072 12.9705 19.513 12.7976 19.5 12.1856L19.4674 4.09104C19.4262 3.42667 19.0341 3.24539 18.4568 3.55242L13.8621 5.64057M3.25 14.5H11.6055C12.8481 14.5 13.8555 13.5051 13.8555 12.2778L13.8752 9.42754L13.8555 3.72222C13.8555 2.49492 12.8481 1.5 11.6055 1.5H3.25C2.00736 1.5 1 2.49492 1 3.72222V12.2778C1 13.5051 2.00736 14.5 3.25 14.5Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/production.301dd976f7e042e30ad75089bdf8338c.svg";
export { ForwardRef as ReactComponent };